import type { RootState } from '../../store';
import type { Notification } from '../types/notification';

const getNotifications = (state: RootState): Notification[] => state.notificaiton.notification;

const notificationSelector = {
  getNotifications,
};

export default notificationSelector;
